


























import Vue from 'vue'
import vueJsonEditor from 'vue-json-editor/vue-json-editor.vue'

export default Vue.extend({
  name: 'JsonEditor',
  components: {
    vueJsonEditor
  },
  props: {
    value: {
      required: true,
      type: [ Number, String, Array, Object ]
    },
    label: {
      required: false,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editorValue: {},
      errorMessage: 'The value is invalid',
      showError: false
    }
  },
  watch: {
    value (val: any) {
      this.$set(this, 'editorValue', val || {})
    }
  },
  mounted () {
    this.$set(this, 'editorValue', this.value || {})
  },
  methods: {
    onJsonChange (value: any) { // triggered only when JSON is valid
      this.showError = false
      this.$emit('input', value)
    },
    onError () { // fixme! value doesn't change when error occur
      this.showError = true
    }
  }
})
